define('shared/util/PopUpManager',[
    'shared/lib/RSVP'
], function(
    RSVP
){
    'use strict';

    function Handler(manager) {
        this._manager = manager;
        this._resolveOffPromise = null;
        this._offPromise = null;
    }

    Handler.prototype.on = function() {
        var me = this;
        if (me._offPromise) {
            return RSVP.resolve();
        }

        me._offPromise = new RSVP.Promise(function(rs){
            me._resolveOffPromise = rs;
        });

        return new RSVP.Promise(function(rs){
            me._manager.currentPromise = me._manager.currentPromise.then(function(){
                rs();
                return me._offPromise;
            });
        });
    };

    Handler.prototype.off = function() {
        var me = this;
        if (me._offPromise == null) {
            return RSVP.resolve();
        }

        var ret = me._offPromise;
        me._offPromise = null;

        // simulate the tick
        setTimeout(function(){
            me._resolveOffPromise();
        });

        return ret;
    };

    function Ctor() {
        this.currentPromise = RSVP.resolve();
    }

    Ctor.prototype.getHandler = function() {
        return new Handler(this);
    };

    Ctor.instance = new Ctor();

    return Ctor;
});
